import { UserRole } from '@services/core/auth/auth.types';
import { useSelector } from 'react-redux';
import { getUser } from '@features/auth/auth.slice';

type PermissionProps = { 
    role: UserRole|UserRole[]|null|undefined,
    children: React.ReactNode
};

export const Permission: React.FC<PermissionProps> = ({ role, children }) => {
    const user = useSelector(getUser);

    if(!role) return <>{children}</>;

    const roles = Array.isArray(role) ? role : [role];
    if (user && roles?.includes(user.role)) {
        return <>{children}</>;
    }

    return null;
};
